import type { Stay } from '../reserva/types'
import type { Guide, GuiaService, GuideSection } from './types'

/**
 * Secciones de la guía: la app actual enseña el manual y las normas en dos listas (ListItemView.tsx); el diseño las une en
 * un acordeón, con el manual primero. El Wi-Fi se muestra con la red aunque falte la clave: la pantalla pide la clave a la propiedad.
 */
export function guideFromStay(stay: Pick<Stay, 'guide' | 'wifi'>): Guide {
  const toSection =
    (prefix: string) =>
    (item: Stay['guide']['manual'][number], i: number): GuideSection => ({ id: `${prefix}-${i}`, title: item.name, content: item.description, iconUrl: item.iconUrl, images: item.images, videos: item.videos })
  return {
    wifi: stay.wifi.ssid ? { ssid: stay.wifi.ssid, password: stay.wifi.password } : null,
    sections: [...stay.guide.manual.map(toSection('manual')), ...stay.guide.conditions.map(toSection('normas'))],
    phones: stay.guide.phones,
    // "Cerca de ti" no existe en la API actual (inventario 8.7): se oculta, sin datos de ejemplo (D36).
    nearby: null,
  }
}

export const guiaReal: GuiaService = {
  getGuide(stay) {
    return Promise.resolve(guideFromStay(stay))
  },
}
